module.exports = __webpack_public_path__ + "static/media/logoOpt.85b87e25.png";